import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pt-3" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "-my-2 sm:-mx-6 lg:-mx-8" }
const _hoisted_4 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_5 = { class: "shadow border-b border-gray-200 sm:rounded-lg" }
const _hoisted_6 = {
  key: 0,
  class: "p-8"
}
const _hoisted_7 = {
  key: 1,
  class: "p-8 flex justify-center"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "base-table overflow-hidden overflow-x-auto" }
const _hoisted_10 = { class: "bg-gray-50" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", { class: "pl-3 py-3" }, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "p-3 text-center" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "pl-3 py-2 text-left text-sm" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "whitespace-nowrap font-semibold text-gray-500"
}
const _hoisted_22 = {
  key: 2,
  class: "whitespace-nowrap font-semibold text-gray-500"
}
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { class: "flex text-sm border-t border-gray-200" }
const _hoisted_25 = { class: "flex-auto" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" SQL ")
const _hoisted_27 = {
  key: 0,
  class: "flex-none whitespace-nowrap paging"
}
const _hoisted_28 = { class: "flex-auto text-right" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4 inline",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
  })
], -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Graph ")
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_ChevronUpIcon = _resolveComponent("ChevronUpIcon")!
  const _component_LitReviewButton = _resolveComponent("LitReviewButton")!
  const _component_paper_modal_button = _resolveComponent("paper-modal-button")!
  const _component_Authors = _resolveComponent("Authors")!
  const _component_DocumentReportIcon = _resolveComponent("DocumentReportIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_paginate = _resolveComponent("paginate")!
  const _component_SaveDropDown = _resolveComponent("SaveDropDown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.errorMsg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errorMsg), 1))
              : (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_Loader)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("table", _hoisted_9, [
                      _createElementVNode("thead", _hoisted_10, [
                        _createElementVNode("tr", null, [
                          _hoisted_11,
                          (_ctx.hasPaperID())
                            ? (_openBlock(), _createElementBlock("th", _hoisted_12))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
                            return (_openBlock(), _createElementBlock("th", {
                              class: "whitespace-nowrap",
                              key: index
                            }, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.sortBy(column)),
                                class: _normalizeClass({ 'font-bold': column == _ctx.sortedBy })
                              }, [
                                _createTextVNode(_toDisplayString(column) + " ", 1),
                                (column == _ctx.sortedBy && _ctx.sortDescending)
                                  ? (_openBlock(), _createBlock(_component_ChevronDownIcon, {
                                      key: 0,
                                      class: "w-4 h-4 inline"
                                    }))
                                  : _createCommentVNode("", true),
                                (column == _ctx.sortedBy && !_ctx.sortDescending)
                                  ? (_openBlock(), _createBlock(_component_ChevronUpIcon, {
                                      key: 1,
                                      class: "w-4 h-4 inline"
                                    }))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_13)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (!_ctx.results || _ctx.results.length == 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                              _createElementVNode("td", _hoisted_15, [
                                (_ctx.emptyMessage)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.emptyMessage), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_17, "No results. Try adjusting your filters. "))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedResults, (result, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: index,
                            class: _normalizeClass(_ctx.rowClass(index))
                          }, [
                            (_ctx.hasPaperID())
                              ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                                  _createVNode(_component_LitReviewButton, {
                                    ids: _ctx.ids,
                                    id: (result.paper_id as PaperID)
                                  }, null, 8, ["ids", "id"])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", _hoisted_19, [
                              _createVNode(_component_paper_modal_button, {
                                class: _normalizeClass(['block', 'font-semibold', 'pb-2', 'text-left']),
                                id: (result.paper_id as PaperID),
                                contextIds: _ctx.ids,
                                text: (result.title ? result.title : result.paper_id) as string
                              }, null, 8, ["id", "contextIds", "text"]),
                              (result.authors)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createVNode(_component_Authors, {
                                      authors: (result.authors as Author[]),
                                      ids: _ctx.ids
                                    }, null, 8, ["authors", "ids"])
                                  ]))
                                : _createCommentVNode("", true),
                              (result.affiliation)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(result.affiliation), 1))
                                : _createCommentVNode("", true),
                              (result.author_name)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createVNode(_component_Authors, {
                                      authors: [
                          {
                            author_id: 0,
                            name: result.author_name as string,
                            sequence: 0,
                          }
                        ],
                                      authorClass: [
  'font-semibold',
  'text-gray-600',
  'underline'
],
                                      ids: _ctx.ids
                                    }, null, 8, ["authors", "ids"])
                                  ]))
                                : _createCommentVNode("", true),
                              (
                        result.year || result.published_year || result.journal
                      )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                    _createTextVNode(_toDisplayString(result.year ? `(${result.published_year})` : '') + " ", 1),
                                    _createElementVNode("i", null, _toDisplayString(result.journal), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
                              return (_openBlock(), _createElementBlock("td", {
                                class: "whitespace-nowrap text-sm",
                                key: index
                              }, _toDisplayString(_ctx.format(result[column])), 1))
                            }), 128))
                          ], 2))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_router_link, {
                          to: _ctx.queryLink,
                          title: "View SQL",
                          class: "p-3 sql-button cursor-pointer inline-block"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DocumentReportIcon, { class: "w-4 h-4 inline" }),
                            _hoisted_26
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      (_ctx.numPages > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createVNode(_component_paginate, {
                              modelValue: _ctx.currentPage,
                              "onUpdate:modelValue": [
                                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
                                _ctx.turnPage
                              ],
                              pages: _ctx.numPages,
                              "active-color": "rgba(139, 92, 246)",
                              hideFirstButton: true,
                              hideLastButton: true
                            }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_28, [
                        (_ctx.hasPaperID())
                          ? (_openBlock(), _createBlock(_component_SaveDropDown, {
                              key: 0,
                              ids: _ctx.resultIds,
                              class: "pt-2"
                            }, null, 8, ["ids"]))
                          : _createCommentVNode("", true),
                        (_ctx.canViewGraphs())
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewGraph())),
                              title: "ViewGraph",
                              class: "p-3"
                            }, _hoisted_31))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
          ])
        ])
      ])
    ])
  ]))
}